import { LocationSensorState } from "react-use/lib/useLocation"
import { Path } from "../navigation"

const getNormalizedPath = (path: string) =>
  path.endsWith("/") ? path : path + "/"
export const getCurrentLocation = (location: LocationSensorState) =>
  location && location.pathname ? getNormalizedPath(location.pathname) : ""

export const checkIfIsMainPage = (pathname: string) => {
  return pathname === Path.Home || pathname === `/pl${Path.Home}`
}

export const checkIfIsOnlyMainPage = (pathname: string) => {
  return pathname === Path.Home || pathname === `/pl${Path.Home}`
}
